import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className='footer'>
            <p>&copy; {new Date().getFullYear()} FactSense.&nbsp;&nbsp;&nbsp;All rights reserved.</p>
            <p>Contact:&nbsp;&nbsp;&nbsp;jessie.apps.store@gmail.com</p>
            
        </footer>
    );
};

export default Footer;